var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-tabs",
    {
      staticClass: "std-prescription-tabs-info",
      attrs: { type: "card" },
      model: {
        value: _vm.activeTab,
        callback: function ($$v) {
          _vm.activeTab = $$v
        },
        expression: "activeTab",
      },
    },
    _vm._l(_vm.pageData.dTableConfig, function (tab) {
      return _c(
        "el-tab-pane",
        {
          key: tab.key,
          staticClass: "h-full",
          attrs: { name: tab.key, label: tab.name },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "ik-list-table min-h-50v",
              attrs: {
                data: _vm.pageData.formData.body[tab.key],
                "element-loading-text": "加载中...",
                stripe: true,
                border: true,
                fit: true,
                height: "100%",
                "header-row-class-name": "ik-list-table-header-row",
                "header-cell-class-name": "ik-list-table-header-cell",
                "row-class-name": "ik-list-table-body-row",
                "cell-class-name": "ik-list-table-body-cell",
                "highlight-current-row": true,
              },
            },
            [
              _vm.pageData.mode !== "details"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "plus",
                      label: "操作",
                      align: "center",
                      width: "180",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "button-action" },
                                [
                                  _c("span", { staticClass: "option-label" }, [
                                    _vm._v("操作"),
                                  ]),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "option-btn",
                                      attrs: { circle: "", title: "添加首行" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addRow(tab.key, -1)
                                        },
                                      },
                                    },
                                    [_vm._v("+ ")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "button-action" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "option-large-btn",
                                      attrs: { circle: "" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.addRow(
                                            tab.key,
                                            scope.$index
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("+ ")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "option-large-btn",
                                      attrs: { circle: "" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.delRow(
                                            tab.key,
                                            scope.$index
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("- ")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                : _vm._e(),
              _vm._l(tab.columns, function (column, index) {
                return [
                  column.type === "oss"
                    ? _c(
                        "table-image-item",
                        _vm._b(
                          {
                            key: index,
                            attrs: {
                              code: column.code,
                              name: column.name,
                              edit: _vm.pageData.mode !== "details",
                            },
                          },
                          "table-image-item",
                          column.config,
                          false
                        )
                      )
                    : column.type === "number"
                    ? _c(
                        "table-number-item",
                        _vm._b(
                          {
                            key: index,
                            attrs: {
                              code: column.code,
                              name: column.name,
                              edit: _vm.pageData.mode !== "details",
                            },
                          },
                          "table-number-item",
                          column.config,
                          false
                        )
                      )
                    : column.type === "datetime"
                    ? _c(
                        "table-datetime-item",
                        _vm._b(
                          {
                            key: index,
                            attrs: {
                              code: column.code,
                              name: column.name,
                              edit: _vm.pageData.mode !== "details",
                            },
                          },
                          "table-datetime-item",
                          column.config,
                          false
                        )
                      )
                    : column.type === "group"
                    ? _c(
                        "table-group-item",
                        _vm._b(
                          {
                            key: index,
                            attrs: {
                              code: column.code,
                              "data-down": _vm.listLoading,
                              name: column.name,
                              edit: _vm.pageData.mode !== "details",
                            },
                          },
                          "table-group-item",
                          column.config,
                          false
                        )
                      )
                    : column.type === "video"
                    ? _c(
                        "table-video-item",
                        _vm._b(
                          {
                            key: index,
                            attrs: {
                              code: column.code,
                              "key-field": "key",
                              "value-field": "value",
                              name: column.name,
                              edit: _vm.pageData.mode !== "details",
                            },
                          },
                          "table-video-item",
                          column.config,
                          false
                        )
                      )
                    : column.type === "time"
                    ? _c(
                        "table-time-item",
                        _vm._b(
                          {
                            key: index,
                            attrs: {
                              code: column.code,
                              "key-field": "key",
                              "value-field": "value",
                              name: column.name,
                              edit: _vm.pageData.mode !== "details",
                            },
                          },
                          "table-time-item",
                          column.config,
                          false
                        )
                      )
                    : column.type === "select"
                    ? _c(
                        "table-select-item",
                        _vm._b(
                          {
                            key: index,
                            attrs: {
                              code: column.code,
                              "key-field": "key",
                              "value-field": "value",
                              name: column.name,
                              edit: _vm.pageData.mode !== "details",
                            },
                          },
                          "table-select-item",
                          column.config,
                          false
                        )
                      )
                    : column.type === "popup"
                    ? _c(
                        "table-popup2-item",
                        _vm._g(
                          _vm._b(
                            {
                              key: index,
                              attrs: {
                                code: column.code,
                                name: column.name,
                                edit: _vm.pageData.mode !== "details",
                                search: {},
                              },
                            },
                            "table-popup2-item",
                            column.config,
                            false
                          ),
                          column.handleEvent
                        )
                      )
                    : _c(
                        "table-text-item",
                        _vm._b(
                          {
                            key: index,
                            attrs: {
                              code: column.code,
                              name: column.name,
                              edit: _vm.pageData.mode !== "details",
                            },
                          },
                          "table-text-item",
                          column.config,
                          false
                        )
                      ),
                ]
              }),
            ],
            2
          ),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }